import Swiper, { Navigation } from 'swiper';

export default class VideoCarousel {
	constructor(sliderElement) {
		const parent = sliderElement.closest('[data-video-carousel-module]');
		const nextButton = parent.querySelector('.swiper-button-next');
		const prevButton = parent.querySelector('.swiper-button-prev');

		const options = {
			direction: 'horizontal',
			slidesPerView: 1.2,
			spaceBetween: 20,
			lazy: true,
			speed: 1000,
			keyboard: true,
			modules: [Navigation],

			breakpoints: {
				1200: {
					slidesPerView: 2.2,
				},
			},

			a11y: {
				prevSlideMessage: 'Vorige slide',
				nextSlideMessage: 'Volgende slide',
			},

			navigation: {
				nextEl: nextButton,
				prevEl: prevButton,
			},
		};

		this.swiper = new Swiper(sliderElement, options);
	}
}
